<template>
  <div>
    <CRow>
      <CCol sm="12" md="12" lg="12" xl="8">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Citas" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'"
          :actions="true" :myButtons="myButtons" @mtd_qr="mtd_qr">
        </CTableWrapper>
      </CCol>
      <CCol sm="12" md="12" lg="12" xl="4" v-if="showQR">
        <CCard accent-color="primary" class="h-100">
          <CCardHeader class="d-flex justify-content-between">
            <span><i class="fas fa-user-check"></i> Registrar Asistencia</span>
          </CCardHeader>
          <CCardBody class="d-flex justify-content-center align-items-center">
            <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="Código QR" width="320" height="320" />
            <p v-else>Cargando QR...</p>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Personal", _style: "width:10%;" },
];
import QRCode from "qrcode";
import { mapActions } from "vuex";
import CTableWrapper from "../../components/shared/datatable/Table.vue";

import moment from "moment";
export default {
  name: "components-asistencia",
  components: {
    CTableWrapper,
  },
  data() {
    return {
      prefix: "assists",
      qrCodeUrl: "",
      showQR: false,
      fields,
      data: [],
      refreshInterval: null,
      myButtons: [
        {
          class: "btn-sm",
          color: "dark",
          tooltip: "QR",
          action: "mtd_qr",
          icon: "fas fa-qrcode",
        },
      ],
    };
  },
  created() {
    this.mtd_data();
  },
  beforeDestroy() {
    if (this.refreshInterval) clearInterval(this.refreshInterval);
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdBack: function () {
      this.$emit("setView", "home");
    },
    async generateQRCode(uuid, userId) {
      try {
        const today = moment().format("YYYY-MM-DD");
        const url = `${this.$store.getters.get__url}/assists/confirm/${uuid}/${userId}/${today}`;
        this.qrCodeUrl = await QRCode.toDataURL(`${url}`);
        this.showQR = true;
      } catch (err) {
        console.error("Error al generar el QR:", err);
      }
    },
    mtd_data() {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/byEncargados/" +
          this.$store.getters.get_company.id + "/" + this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.data = response.data.data.map((item, index) => ({
              ...item,
              name: `${item.name} ${item.last_name}`,
              index: index + 1
            }));
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    // mtd_qr(item) {
    //   this.generateQRCode(item.company.uuid, item.user_id);
    // }
    async mtd_qr(item) {
      try {
        const response = await this.post({
          url: this.$store.getters.get__url + "/assists/generate-token",
          token: this.$store.getters.get__token,
          params: {
            user_id: item.user_id,
            company_uuid: item.company.uuid,
          }
        });

        if (response.statusCode === 200) {
          const tempToken = response.data.token;
          const baseUrl = this.$store.getters.get__url.replace('/api/v1', '');
          const url = `${baseUrl}/asistencia/confirm/${tempToken}`;

          this.qrCodeUrl = await QRCode.toDataURL(url);
          this.showQR = true;

          if (this.refreshInterval) clearInterval(this.refreshInterval);
          this.refreshInterval = setInterval(() => this.mtd_qr(item), 4 * 60 * 1000);
        }
      } catch (err) {
        console.error("Error al generar token:", err);
      }
    },

    async generateQRCode(tempToken) {
      const url = `${this.$store.getters.get__url}/assists/confirm/${tempToken}`;
      this.qrCodeUrl = await QRCode.toDataURL(url);
      this.showQR = true;
    },

    startTokenRefresh(item) {
      // Limpiar intervalo anterior si existe
      if (this.refreshInterval) clearInterval(this.refreshInterval);

      // Regenerar cada 4 minutos (antes de los 5 min de TTL)
      this.refreshInterval = setInterval(() => {
        this.mtd_qr(item);
      }, 4 * 60 * 1000);
    },
  },
}
</script>